module.exports = __webpack_public_path__ + "img/portfolio1.2c255bb7.png";